import { useCallback, useState } from 'react'

import { useDeleteCompany as useHook } from 'commons/hooks/bank/company'
import { Toast } from 'ui/components/Toast'
import { useConfirmation } from 'ui/hooks'

import { handlerServerError } from '@orbit/errors'

export const useCompanyDelete = (onSuccess: () => void) => {
  const [companyForDelete, setCompanyForDelete] = useState<{ id: number | null; name: string | null } | null>(null)
  const { routine: deleteCompany } = useHook({
    onSuccess: async () => {
      await onSuccess()
      Toast.successSmall(`Company "${companyForDelete?.name}" was successfully deleted.`)
    },
    onError: (error) => handlerServerError(error)
  })

  const deleteChosenCompany = useCallback(() => {
    if (companyForDelete?.id) {
      deleteCompany(companyForDelete?.id)
    }
  }, [deleteCompany, companyForDelete])

  const { Confirmation: DeleteConfirmation, open: openDeleteConfirmation } = useConfirmation({
    message: `Are you sure you want to delete "${companyForDelete?.name || 'this'}" company?`,
    onConfirm: deleteChosenCompany,
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true,
    onCancel: () => setCompanyForDelete(null)
  })

  const onDeleteCompany = useCallback(
    (company: { id: number | null; name: string | null }) => {
      setCompanyForDelete(company)
      openDeleteConfirmation()
    },
    [openDeleteConfirmation, setCompanyForDelete]
  )

  return {
    DeleteConfirmation,
    onDeleteCompany,
    companyForDelete
  }
}
